import { Bar } from "react-chartjs-2";
import { Card, CardTitle, Col, Row } from "reactstrap";
import { FormattedMessage } from "react-intl";

const CourseModulesResultsBar = ({ primaryData, secondaryData }) => {
  if (!primaryData?.datasets || !secondaryData?.datasets) return null;

  const options = {
    responsive: true,
    indexAxis: "y",
    plugins: {
      legend: {
        onClick: null,
      },
    },
    scales: {
      y: {
        stacked: true,
        ticks: {
          beginAtZero: true,
        },
      },
      x: {
        stacked: true,
      },
    },
  };

  return (
    <Col lg={12} xs={12} className="px-0 my-2">
      <Card body>
        <CardTitle>
          <FormattedMessage id="ModuleResultInCourse" />
        </CardTitle>
        <hr />
        <Row>
          <Col lg={6} sm={12}>
            <Bar data={primaryData} options={options} />
          </Col>
          <Col lg={6} sm={12}>
            <Bar data={secondaryData} options={options} />
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default CourseModulesResultsBar;
